import { Component, Input, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DialogResult } from '@progress/kendo-angular-dialog';
import { Observable } from 'rxjs';
import {  tap } from 'rxjs/operators';
import { UiNotificationService } from 'src/app/external-ui-shared/services/ui-notification.service';
import { ShowProofLinkedDocsComponent } from 'src/app/feature-module/documents/component/show-proof-linked-docs/show-proof-linked-docs.component';
import { DocumentService } from 'src/app/feature-module/documents/service/document.service';
import { CustomDialogSettings } from 'src/app/shared/model/CustomDialogSettings';
import { CustomDialogService } from 'src/app/shared/services/custom-dialog.service';
import { ProofDocument, ProofDocumentFormBuilder } from '../../models/ProofDocument';
import { ManageProofDocumentComponent } from '../manage-proof-document/manage-proof-document.component';
import { CurrentClaimDataService } from 'src/app/feature-module/claims-data/service/current-claim-data.service';


@Component({
  selector: 'app-proof-docs',
  templateUrl: './proof-docs.component.html',
  styleUrls: ['./proof-docs.component.scss']
})
export class ProofDocsComponent implements OnInit {

  @Input() inputClaimId: string;
  claimId: string;
  proofDocuments$: Observable<ProofDocument[]>;
  isLoading:boolean;
  changed = false;

  constructor(private activatedRoute: ActivatedRoute,
    private documentService: DocumentService,
    private customDialogService: CustomDialogService,
    private currentClaimDataService: CurrentClaimDataService,
    private uiNotification: UiNotificationService) { }

        
   @ViewChild("proofDocsDialog", { read: ViewContainerRef })
   public containerRef: ViewContainerRef;
   
  ngOnInit() {
   
    if(this.inputClaimId){
      this.claimId = this.inputClaimId;
      this.loadData();
    }
    else{
      this.claimId = this.activatedRoute.snapshot.paramMap.get('id');
      this.loadData();
    }

   
  }

  loadData(){
    this.isLoading = true;
    this.proofDocuments$ = this.documentService.getProofDocuments( this.claimId).pipe(
      tap(()=> this.isLoading = false)
    );
  }

  refresh(){
    this.changed = true;
    this.loadData();
    this.currentClaimDataService.RefreshCurrentClaimSearchResultItem(this.claimId);
    this.currentClaimDataService.RefreshCurrentClaim(this.claimId);
  }

  add() {

    const assignData =  ProofDocumentFormBuilder.initProofDocument();
    assignData.claimIdentifier = this.claimId;
    
    const dialogSettings: CustomDialogSettings = {
      content: ManageProofDocumentComponent,
      appendTo: this.containerRef,
      dialogInputs: {
        inputData : assignData
      },
      resultCallback: (r: DialogResult) => {
        if(r['text'] == 'OK') {
          this.refresh()
         }
      }
    };

    this.customDialogService.showDialog(dialogSettings);
  }


  edit(editedProof:ProofDocument){

    const dialogSettings: CustomDialogSettings = {
      content: ManageProofDocumentComponent,
      appendTo: this.containerRef,
      dialogInputs: {
        inputData : editedProof
      },
      resultCallback: (r: DialogResult) => {
        if(r['text'] == 'OK') {
          this.refresh();
         }
      }
    };

    this.customDialogService.showDialog(dialogSettings);
  }

  remove(proof:ProofDocument){
   
    this.customDialogService.actionWithConfirmation('claims-center.claimDocumentation.doYouReallyWantToDeleteThisProofDocument',
    () => {
      this.documentService.removeProofDocument(proof.claimIdentifier,proof.id).subscribe(
        () => { 
          this.uiNotification.showSuccess('validations.dataRemovedSuccesfully');
          this.refresh();
         });
        },
        this.containerRef);
  }

  approve(proof:ProofDocument){
    proof.conformityId = 2;
    this.documentService.storeProofDocument(proof).subscribe(
      () => { 
        this.uiNotification.showSuccess('validations.dataUpdatedSuccesfully');
        this.refresh();
       });
  }

  showLinkedDocs(proof:ProofDocument){

    const dialogSettings: CustomDialogSettings = {
      content: ShowProofLinkedDocsComponent,
      maxWidth: '90vw',
      maxHeight: '90vh',
      appendTo: this.containerRef,
      dialogInputs: {
        proofDocumentId : proof.id
      },
      resultCallback: (r: DialogResult) => {
        if(r['text'] == 'OK') {
          this.refresh();
         }
      }
    };

    this.customDialogService.showDialog(dialogSettings);
 }

}
